import { getUserInfo } from "../Api/index";
export default {
    state: {
        userInfo: {},
        qr: null,
        isPromoActive: false,
    },
    mutations: {
        SET_USERINFO(state, payload) {
            state.userInfo = payload;
        },
        CREATE_QR(state) {
            const number = state.userInfo.abonement;
            const number_base_64 = btoa(number);
            state.qr = number_base_64;
        },
        SET_IS_PROMO_ACTIVE(state, payload) {
            if (payload) {
                document.body.className = "hidden";
            } else {
                document.body.className = "auto";
            }
            state.isPromoActive = payload;
        },
    },

    actions: {
        async getUserInfo({ commit }) {
            if (this.state.user.userInfo && this.state.user.userInfo.abonement)
                return;
            const response = await getUserInfo();
            commit("SET_USERINFO", response);
            commit("CREATE_QR");
        },
        checkPromo({ commit }) {
            const token = localStorage.getItem("token");
            if (token) {
                commit("SET_IS_PROMO_ACTIVE", false);
                return;
            }
            const isPromoWatched = localStorage.getItem("isPromoWatched");
            if (isPromoWatched) {
                commit("SET_IS_PROMO_ACTIVE", false);
                const isPromoWatchedTime =
                    localStorage.getItem("isPromoWatchedTime");
                const time = Date.now() - Number(isPromoWatchedTime);
                if (time > 86400000) {
                    commit("SET_IS_PROMO_ACTIVE", true);
                    localStorage.setItem("isPromoWatched", true);
                    localStorage.setItem("isPromoWatchedTime", Date.now());
                }
            } else {
                commit("SET_IS_PROMO_ACTIVE", true);
                localStorage.setItem("isPromoWatched", true);
                localStorage.setItem("isPromoWatchedTime", Date.now());
            }
        },
    },

    getters: {
        getQr(state) {
            return state.qr;
        },
        getIsPromoActive(state) {
            return state.isPromoActive;
        },
    },
};
